export type PermitApplicationEventType =
  | "status_changed"
  | "deadline_changed"
  | "task_created"
  | "task_completed"
  | "task_reopened"
  | "task_removed"
  | "assignee_changed"
  | "reviewer_added"
  | "reviewer_removed"
  | "reviewer_decision_changed";

export type PermitApplicationEvent = {
  id: number;
  permit_application_id: number;
  user_id: number;
  actor_name: string;
  event_type: PermitApplicationEventType;
  metadata: Record<string, unknown>;
  created_at: string;
};

export async function listPermitApplicationEvents(
  municipalityId: number,
  applicationId: number,
): Promise<PermitApplicationEvent[]> {
  const response = await fetch(
    `/api/v1/municipalities/${municipalityId}/permit_applications/${applicationId}/events`,
    { credentials: "include", headers: { Accept: "application/json" } },
  );
  if (!response.ok) throw new Error("Failed to load events");
  return response.json();
}
